import Vue from 'vue';
import { EstateDetailsMainTabValue } from '@/modules/ops/constants/EstateDetailsMainTabValue';
import { EstateDetailsCollapsesTabValue } from '@/modules/ops/constants/EstateDetailsCollapsesTabValue';

export class EstateDetailsShowConfig {
  component: Vue;
  modelId: number;
  tab?: EstateDetailsMainTabValue | EstateDetailsCollapsesTabValue;

  constructor(config: Partial<EstateDetailsShowConfig> = {}) {
    this.component = config.component!;
    this.modelId = config.modelId as number;
    this.tab = config.tab;
  }
}
